import { render } from "./ToastContainer.vue?vue&type=template&id=fa56c6aa"
import script from "./ToastContainer.vue?vue&type=script&lang=js"
export * from "./ToastContainer.vue?vue&type=script&lang=js"

import "./ToastContainer.vue?vue&type=style&index=0&id=fa56c6aa&lang=scss"

import exportComponent from "/Users/Ralph/repos/verduurzamen/quickcheck/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__